import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchOperatorSkillOperations({ operatorSkillOperationsParams }) {
  try {
    yield put(Actions.setOperatorSkillOperationsLoaderStatus({ operatorSkillOperationsLoader: true }));
    const { data } = yield call(api.get, {
      route: 'labourskill/getsearched',
      params: operatorSkillOperationsParams,
    });
    const operatorSkillOperationsData = data;
    yield put(Actions.setOperatorSkillOperations({ operatorSkillOperationsData }));
    yield put(Actions.setOperatorSkillOperationsLoaderStatus({ operatorSkillOperationsLoader: false }));
  } catch (err) {
    yield put(Actions.setOperatorSkillOperationsLoaderStatus({ operatorSkillOperationsLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addUpdateOperatorSkillOperation({ actionName, operatorSkillOperationObj, operatorSkillOperationsParams }) {
  try {
    yield put(Actions.setOperatorSkillOperationsLoaderStatus({ operatorSkillOperationsLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.UPDATE ? api.put : api.post, {
      route: `labourskill`,
      data: operatorSkillOperationObj,
    });
    yield put(Actions.fetchOperatorSkillOperations({ operatorSkillOperationsParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.OPERATOR_SKILL_CREATED
        : CONSTANT_VARIABLES.OPERATOR_SKILL_UPDATED,
      ''
    );
  } catch (err) {
    yield put(Actions.setOperatorSkillOperationsLoaderStatus({ operatorSkillOperationsLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteOperatorSkillOperation({ operatorSkillId, operatorSkillOperationsParams }) {
  try {
    yield put(Actions.setOperatorSkillOperationsLoaderStatus({ operatorSkillOperationsLoader: true }));
    yield call(api.delete, {
      route: `labourskill/${operatorSkillId}`,
    });
    yield put(Actions.fetchOperatorSkillOperations({ operatorSkillOperationsParams }));
    notification('success', CONSTANT_VARIABLES.OPERATOR_SKILL_DELETED, '');
  } catch (err) {
    yield put(Actions.setOperatorSkillOperationsLoaderStatus({ operatorSkillOperationsLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_OPERATOR_SKILL_OPERATIONS, fetchOperatorSkillOperations),
    takeLatest(ActionTypes.ADD_UPDATE_OPERATOR_SKILL_OPERATION, addUpdateOperatorSkillOperation),
    takeLatest(ActionTypes.DELETE_OPERATOR_SKILL_OPERATION, deleteOperatorSkillOperation),
  ]);
}
